<template>
  <v-card v-if="distributor">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="save">generate</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs9>
            <h3 class="display-2">{{distributor.name}}</h3>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              label="Order"
              v-model="order"
              mask="#####"
              :error-messages="orderErrors"
              @input="$v.order.$touch()"
              @blur="$v.order.$touch()"
              required
            ></v-text-field>
          </v-flex>
          <span class="subheading">You can change order for distributor, and set count of codes for each SKU. If count will be greater then 0 - codes will be generated.</span>
          <v-flex xs11>
            <v-divider class="my-3"></v-divider>
          </v-flex>
          <v-flex xs12 v-for="sku in skuList" :key="sku.id">
            <sku-generate
              :distributor="distributor"
              :sku="sku"
              :order="order"
            >
            </sku-generate>
          </v-flex>
          <v-flex xs11>
            <v-divider class="my-3"></v-divider>
          </v-flex>
          <span class="subheading">If some codes won't generated (red sign), just try to change the name (maybe some codes with same name was generated.</span>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-snackbar :timeout="3000" v-model="snackBar" bottom right>
      {{ snackBarText }}
      <v-btn flat color="pink" @click="snackClose">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { snackbar } from '../../mixins/snackbar'
import { required, numeric, minValue, maxValue } from 'vuelidate/lib/validators'
import { DISTRIBS_LIST } from '../../store/actions/distributors'
import { SKU_LIST } from '../../store/actions/sku'
import { mapGetters } from 'vuex'
import api from '../../api/distributors'
import SkuGenerate from '@/components/Codes/SkuGenerate'

export default {
  mixins: [validationMixin, snackbar],
  validations: {
    order: { required, numeric, minValue: minValue(1), maxValue: maxValue(20000) }
  },
  props: ['title', 'distributor'],
  data: () => ({
    isUpdate: false,
    order: null
  }),
  methods: {
    close: function () {
      this.$v.$reset()
      this.distributor = null
      this.$root.$emit('close')
      this.$forceUpdate()
      this.$emit('close')
    },
    save: function () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      this.$root.$emit('generate')
    },
    getOrder: async function () {
      this.order = parseInt(await api.getMaxOrder(this.distributor.id)) + 1
    }
  },
  computed: {
    ...mapGetters([
      'distributors',
      'skuList',
      'codes'
    ]),
    orderErrors () {
      const errors = []
      if (!this.$v.order.$dirty) return errors
      !this.$v.order.required && errors.push('Order is required')
      !this.$v.order.numeric && errors.push('Order must be numeric')
      !this.$v.order.minValue && errors.push('Order min value 1')
      !this.$v.order.maxValue && errors.push('Order max value 20000')
      return errors
    }
  },
  created: async function () {
    await this.$store.dispatch(DISTRIBS_LIST)
    await this.$store.dispatch(SKU_LIST)
  },
  mounted: async function () {
    if (this.distributor) {
      this.getOrder()
    }
  },
  watch: {
    distributor () {
      this.getOrder()
    }
  },
  components: {
    SkuGenerate
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Codes/DistributorDialog.vue